import React, { ReactElement } from 'react';
import { Tabs } from 'antd';
import { Address, Breeder, Customer, Puppy } from 'types';
import { PuppyCard } from './PuppyCard';
import { PersonCard } from './PersonCard';
import { CardTabsStyled } from './CardTabs.style';

const { TabPane } = Tabs;

type CustomerProps = {
  person: Customer | Breeder;
  deliveryAddress?: Address;
  leadId?: number;
  titlePrefix: 'Contact' | 'Breeder';
  className?: string;
};

type PuppyProps = {
  puppy: Puppy;
  classNamePuppy?: string;
  soldDate: string;
};

type Props = {
  puppy: PuppyProps;
  customer: CustomerProps;
  breeder: CustomerProps;
};

export const CardTabs = ({ puppy, customer, breeder }: Props): ReactElement => {
  return (
    <CardTabsStyled>
      <Tabs defaultActiveKey="1">
        <TabPane tab={`Puppy ID ${puppy.puppy.id}`} key="1">
          <PuppyCard
            puppy={{ ...puppy.puppy, soldDate: puppy.soldDate }}
            className={puppy.classNamePuppy}
          />
        </TabPane>
        <TabPane tab={`Customer ID ${customer.leadId}`} key="2">
          <PersonCard
            titlePrefix="Contact"
            person={customer.person}
            leadId={customer.leadId}
            deliveryAddress={customer.deliveryAddress}
          />
        </TabPane>
        <TabPane tab={`Breeder ID ${breeder.person.id}`} key="3">
          <PersonCard titlePrefix="Breeder" person={breeder.person} />
        </TabPane>
      </Tabs>
    </CardTabsStyled>
  );
};
